import React from "react";
import styles from "./TermsAndConditions.module.css";
import { ContactData } from "../../controller/ContactData";

const TermsAndConditions = () => {
  // Separate email and address from ContactData
  const email = ContactData.find((item) => item.id === 1)?.text;
  const phone = ContactData.find((item) => item.id === 2)?.text;
  const address = ContactData.find((item) => item.id === 3)?.text;
  const effectiveDate = "13/02/2026";

  const sections = [
    {
      title: "1.Acceptance of Terms",
      content: [
        "By accessing or using our Website and Services, you acknowledge that you have read, understood and agree to be legally bound by these Terms and our Privacy Policy. We may update or modify these Terms at any time. Changes will be posted on the Website, and continued use after such updates constitutes your acceptance.",
      ],
    },
    {
      title: "2. Eligibility",
      content: [
        "This website isn’t meant for use by children. We don’t collect their personal information. If we find any, we’ll delete it right away. ",
        "This applies only to the website not to Bharat Clouds Private Limited’s products or services, which follow separate policies. ",
      ],
    },
    {
      title: "3. Use of Website and Services",
      content: [
        "You agree to use the Website and Services only for lawful and authorized purposes.",
        "You must not:",
      ],
      list: [
        "Post or transmit unlawful, harmful, or defamatory content.",
        "Attempt to gain unauthorized access to systems or data.",
        "Interfere with the normal functioning of the Website or Services.",
        "Impersonate any individual or entity.",

      ],
    },
    {
      title: "4. Intellectual Property Rights",
      content: [
        "All intellectual property on the Website including text, graphics, logos, images, and software is owned by Bharat Clouds Private Limited. or its licensors. You may not copy, reproduce, or distribute any content without written consent.",      ],
    },
    {
      title: "5. Software and Service Licensing",
      content: [
        "All software or tools provided are licensed, not sold. You are prohibited from reverse-engineering, redistributing, or reselling them. Bharat Clouds reserves the right to update or discontinue any software or Services at any time.",
      ],
    },
    {
      title: "6. User Accounts and Security ",
      content: [
        "You must provide accurate information when creating an account. You are responsible for maintaining your login credentials and all activities under your account. Notify us immediately of any unauthorized use.",
      ],
    },
    {
      title: "7. Privacy and Data Protection ",
      content: [
        "Our data practices are governed by our Privacy Policy. By using our website, you consent to data collection and processing as described in that policy.",
      ],
    },
    {
      title: "8. Third-Party Links ",
      content: [
        "Our website may contain links to third-party sites. We are not responsible for their content, privacy practices, or damages arising from use.",
      ],
    },
    {
      title: "9. Disclaimers",
      content: [
        "The Website and Services are provided “as is.” We make no warranties regarding their accuracy, reliability, or availability. Use is at your own risk.",
      ],
    },
    {
      title: "10. Limitation of Liability",
      content: [
        "To the maximum extent permitted by law, Bharat Clouds Private Limited. shall not be liable for any indirect, incidental, or consequential damages arising from your use of our Website or Services.",
      ],
    },
    {
      title: "11. Indemnification",
      content: [
        "We may suspend or terminate your access for violating these Terms or engaging in unauthorized activities.",
      ],
    },
     {
      title: "12. Termination",
      content: [
        "We may suspend or terminate your access for violating these Terms or engaging in unauthorized activities.",
      ],
    },
    {
      title: "13. Governing Law and Jurisdiction",
      content: [
        "These Terms are governed by the Laws of India. All disputes shall be subject to the exclusive jurisdiction of the courts in Chennai, Tamil Nadu.",
      ],
    },
    {
      title: "14. Changes to Terms ",
      content: [
        "We may revise these Terms periodically. Continued use of our Website after updates constitutes acceptance of the revised Terms.",
      ],
    },
    {
      title: "15. Contact Information",
      content: [
        "For questions or clarifications regarding these Terms, please contact us at: ",
      ],
    },
  ];

  return (
    <div className={styles.termsContainer}>
      {/* Heading */}
      <div className={styles.headingContainer}>
        <h5 className={`${styles.mainHeading}`}>
          Terms and Conditions
        </h5>
      </div>
      <p className={styles.effectiveDate}>
        <strong>Effective Date:</strong> {effectiveDate}
      </p>
      <div className={styles.titleWrapper}>
        <h5 className={`${styles.titleHeading}`}>
          Welcome to Bharat Clouds Private Limited. (“Company,” “we,” “our,” or
          “us”). These Terms and Conditions (“Terms”) govern your access to and
          use of our website https://bharatclouds.com (the “Website”) and any
          software, applications, tools, or services provided by us
          (collectively, the “Services”). By using our Website or Services, you
          agree to comply with these Terms.
        </h5>
      </div>
      {/* Sections */}
      {sections.map((section, index) => (
        <div key={index} className={styles.policySection}>
          <h5>{section.title}</h5>

          {section.content.map((para, i) => (
            <p key={i}>{para}</p>
          ))}

          {section.list && (
            <ul>
              {section.list.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          )}
        </div>
      ))}
      <div className={styles.contactSection}>
        <h5 className={styles.policySectionh5}>Email:</h5>
        <p className={styles.policySectionP}>{email}</p>

        <h5 className={styles.policySectionh5}>Phone:</h5>
        <p className={styles.policySectionP}>{phone}</p>

        <h5 className={styles.policySectionh5}>Address:</h5>
        <p className={styles.policySectionP}>{address}</p>
      </div>
    </div>
  );
};

export default TermsAndConditions;
